module.exports = __webpack_public_path__ + "static/img/prc2017.5eea5e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programs/prc2017.jpg
// module id = I29x
// module chunks = 1